import { render, staticRenderFns } from "./hr_add.vue?vue&type=template&id=3e55c400&scoped=true&"
import script from "./hr_add.vue?vue&type=script&lang=js&"
export * from "./hr_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e55c400",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e55c400')) {
      api.createRecord('3e55c400', component.options)
    } else {
      api.reload('3e55c400', component.options)
    }
    module.hot.accept("./hr_add.vue?vue&type=template&id=3e55c400&scoped=true&", function () {
      api.rerender('3e55c400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/hr/add/hr_add.vue"
export default component.exports